import React from "react";

const FacebookBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3742_105597)">
      <path
        d="M16.0007 0.800049C-2.84478 1.35205 -4.7667 27.7962 13.6135 31.2H16.0007H18.3879C36.7722 27.793 34.8419 1.35013 16.0007 0.800049Z"
        fill="#1877F2"
      />
      <path
        d="M18.3881 20.5134H21.9481L22.6256 16.0929H18.3881V13.2241C18.3881 12.0148 18.9801 10.8359 20.8781 10.8359H22.8048V7.07239C18.6787 6.32904 13.7216 6.55528 13.6137 12.7236V16.0929H9.73438V20.5134H13.6137V31.2001H16.0009H18.3881V20.5134Z"
        fill="#F1F1F1"
      />
    </g>
    <defs>
      <clipPath id="clip0_3742_105597">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FacebookBrand1;
